import { hasPpt, ppt } from "./formatUtils";

/**
 * Whether at least one shape is currently selected in the presentation.
 * Reuses the same `context.presentation.getSelectedShapes()` call already
 * used throughout formatOps.ts/colourOps.ts — there's no separate reactive
 * selection tracker in this app, so callers that require a selection check
 * this on demand right before running instead.
 */
export async function validateSelection(): Promise<boolean> {
  if (!hasPpt()) return false;
  return ppt().run(async (context) => {
    const sel = context.presentation.getSelectedShapes();
    sel.load("items");
    await context.sync();
    return sel.items.length > 0;
  });
}
